import { hashString } from "./hashString";
import getRuntimeConstants from "../runtimeConstants";

export async function getHashedCustomerSegmentsKey(segmentIds) {
  if (!segmentIds || typeof segmentIds !== "string") {
    return null;
  }

  const { returnsRelatedSegmentIds = [] } = getRuntimeConstants();

  const filteredAndSorted = [
    ...new Set(
      segmentIds
        .split(",")
        .filter((id) => returnsRelatedSegmentIds.includes(id)),
    ),
  ].sort();

  if (!filteredAndSorted.length) {
    return null;
  }

  return await hashString(filteredAndSorted.join(","));
}
